import { FlexiFormFullFormI } from './flexiforms.model';
import { PipelineI } from './funnel.model';
import { NoteModel } from './note.model';

export interface StepHistory {
    updated_at: string;
    step_key: string;
    step_name: string;
}

export interface DealModel {
    documentation: any;
    step_history: any;
    form_documentation: any;
    form_documentation_extended: FlexiFormFullFormI;
    trigger_history: any;
    process: any;
    notes: NoteModel[];
}

export interface DealProcessByPipeline {
    pipeline: PipelineI;
    step_history: StepHistory[];
    triggers_completed: any[];
    processes?: DealProcessModel[];
}

export class DealProcessModel {
    public update_at: string;
    public stepName: string;
    public stepKey: string;
    public trigger: any;
    public isNew: boolean;

    constructor(
        updatedAt: string,
        stepKey: string = null,
        stepName: string = null,
        trigger: any = null,
        isNew: boolean = false
    ) {
        this.update_at = updatedAt;
        this.stepName = stepName;
        this.stepKey = stepKey;
        this.trigger = trigger;
        this.isNew = isNew;
    }
}

export interface Coordinator {
    avatar: string;
    email: string;
    first_name: string;
    id: string;
    phone: string;
}

export class TriggerModel {
    public id: number;
    public type: string;
    public date: string;
    public title: string;
    public text: string;
    public data: any;
    public completed: boolean;
    public dealId: string;
    public coordinator: Coordinator;

    constructor(
        id: number,
        type: 'notification' | 'mail' | 'step' | 'form' | 'doc' | 'meeting',
        date: string,
        data: any,
        title: string = null,
        text: string = null,
        completed: boolean = false,
        dealId: string = '',
        coordinator: Coordinator
    ) {
        this.id = id;
        this.type = type;
        this.date = date;
        this.data = data;
        this.title = title;
        this.text = text;
        this.completed = completed;
        this.dealId = dealId;
        this.coordinator = coordinator;
    }

    done(): void {
        this.completed = true;
    }

    unDo(): void {
        this.completed = false;
    }
}

export class DealDocument {
    public category: string;
    public document_file: string;
    public identifier: string;
    public internal: boolean;
    public my_document: boolean;
    public name: string;
    public required: boolean;
    public updated_at: string;
    public user: any;

    public crud: boolean;

    constructor(
        category: string,
        document_file: string,
        identifier: string,
        internal: boolean,
        my_document: boolean,
        name: string,
        required: boolean,
        updated_at: string,
        user: any = null
    ) {
        this.category = category;
        this.document_file = document_file;
        this.identifier = identifier;
        this.internal = internal;
        this.my_document = my_document;
        this.name = name;
        this.required = required;
        this.updated_at = updated_at;
        this.user = user;

        this.crud = this.category === null ? false : true;
    }
}

export class DocumentCategory {
    public name: string;
    public documents: DealDocument[];

    constructor(name: string, documents: DealDocument[]) {
        this.name = name;
        this.documents = documents;
    }
}

export interface QuestionLittleI {
    question: string;
    answer: string;
    nameID: string;
    type?: string;
    isUrl?: boolean;
    url?: string;
}
export interface DealFormAnswersLittleI {
    title: string;
    questions: QuestionLittleI[];
}

export type qType = 'string' | 'boolean' | 'number' | 'float' | 'date';

export interface QuestionParserI {
    nameID: string;
    questionType: qType;
}
